import { Link, useLocation } from "react-router-dom";

function Bottombar() {
  const location = useLocation();
  const pathMatchRoute = (route) => {
    if (route === location.pathname) {
      return true;
    }
  };
  return (
    <div className="fixed bottom-0 left-0 bg-white w-full lg:hidden z-50 border-t border-offWhite md:px-20">
      <nav className="bottom_navi container mx-auto h-20  ">
        <ul className="h-full flex justify-between items-center">
          <li className={pathMatchRoute("/") ? "active" : ""}>
            <Link to="/">
              <i className="fa-solid fa-house"></i>
              <p>HOME</p>
            </Link>
          </li>
          <li className={pathMatchRoute("/portfolio") ? "active" : ""}>
            <Link to="/portfolio">
              <i className="fa-solid fa-book"></i>
              <p>PORTFOLIO</p>
            </Link>
          </li>

          <li className={pathMatchRoute("/services") ? "active" : ""}>
            <Link to="/services">
              <i className="fa-solid fa-hand-holding-hand"></i>
              <p>SERVICES</p>
            </Link>
          </li>
          <li className={pathMatchRoute("/contact") ? "active" : ""}>
            <Link to="/contact">
              <i className="fa-solid fa-address-card"></i>
              <p>CONTACT</p>
            </Link>
          </li>
        </ul>
      </nav>
    </div>
  );
}

export default Bottombar;
